module.exports = __webpack_public_path__ + "img/news24-bg.1d72a67b.jpg";